import React from "react";
import loginImage from "../../Asset/login image.png";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import { FcGoogle } from "react-icons/fc";
import { ReactSVG } from "react-svg";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaApple } from "react-icons/fa";

const Login = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const navigate = useNavigate();
  const handleMicrosoftLogin = () => {
    const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
    const tenant = "common";
    const redirectUri = `${process.env.REACT_APP_BACKEND_URL}api/auth/microsoft`; // must match backend

    const authUrl = `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize?${new URLSearchParams(
      {
        client_id: clientId,
        response_type: "code",
        redirect_uri: redirectUri,
        response_mode: "form_post",
        scope: "openid email profile User.Read",
        prompt: "select_account",

      }
    )}`;

    window.location.href = authUrl;
  };

  const handleAppleLogin = () => {
    const clientId = process.env.REACT_APP_APPLE_CLIENT_ID;
    const redirectUri = `${process.env.REACT_APP_BACKEND_URL}api/auth/apple`;

    const state = Array.from(crypto.getRandomValues(new Uint8Array(16)))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
    sessionStorage.setItem("apple_oauth_state", state);

    const authUrl = `https://appleid.apple.com/auth/authorize?${new URLSearchParams({
      response_type: "code",
      response_mode: "form_post",
      client_id: clientId,
      redirect_uri: redirectUri,
      scope: "name email",
      state
    })}`;
    console.log("auth url ", authUrl)

    window.location.href = authUrl;
  };

  const handleGoogleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = `${process.env.REACT_APP_BACKEND_URL}api/auth/google`; // must match backend

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
      {
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: "code",
        scope: "openid email profile",
        access_type: "offline",
        prompt: "select_account",
      }
    )}`;

    window.location.href = authUrl;
  };

  useEffect(() => {
    if (error) {
      switch (error) {
        case "missing_code":
          toast.error("We couldn’t complete the login. Please try again.");
          break;
        case "user_not_registered":
          toast.error(
            "Your account was not found, please sign up using our application"
          );
          navigate("/download");
          break;
        case "auth_failed":
          toast.error(
            "Login failed. Please check your credentials and try again."
          );
          break;
        case "service_unavailable":
          toast.error(
            "We're experiencing some technical issues and our team is working to fix it. Please try again later."
          );
          break;
        default:
          toast.error("Oops! Something went wrong. Please try again later.");
      }
    }
  }, [error, navigate]);

  return (
    <div className="flex w-full h-screen overflow-hidden p-4">
      {/* Image Section - 60% */}
      <div className="md:w-[55%] md:block hidden h-full relative overflow-hidden ">
        <img
          src={loginImage}
          alt="Login"
          className="w-full h-full object-cover object-left-top rounded-2xl"
        />
        <div className=" absolute  text-white bottom-8 p-3 w-full flex flex-col items-center gap-4">
          <h1 className=" font-jakarta font-semibold text-[2.5rem] leading-tight text-center ">
            Talk. Get it done.
          </h1>
          <p className="font-inter text-[1.25rem] text-center leading-tight">
            Save time and type smarter. Zero Typing AI converts your speech into
            polished, professional content in real time. Log in now and let your
            voice do the work.
          </p>
        </div>
      </div>

      {/* Login Section - 40% */}
      <div className="md:w-[45%] w-full h-full  bg-white ">
        <div className=" flex flex-col items-center md:justify-center justify-between h-full pb-10 md:pb-0 pt-14 md:pt-0">
          <div className=" block md:hidden">
            <ReactSVG
              src={zeroTypingLogo}
              beforeInjection={(svg) => {
                svg.setAttribute("class", "w-auto  h-12");
              }}
              className="w-auto"
            />
          </div>
          <div className=" flex flex-col gap-4 justify-center items-center p-2 h-full text-center">
            <h1 className="md:block hidden font-jakarta font-semibold lg:text-[1.75rem] text-[1.5rem]">
              Your words, instantly typed anywhere.
            </h1>
            <h1 className="block md:hidden font-jakarta font-semibold text-[1.6rem]"> Your words, instantly typed anywhere.


            </h1>
            <p className=" font-inter text-[#4B4B4B] text-center text-wrap lg:text-base sm:text-sm text-[12.7px]">
              With fast, accurate voice dictation powered by AI: Works
              with all your apps.            </p>
            <button
              onClick={() => handleGoogleLogin()}
              className=" flex items-center gap-4 lg:w-[24rem] w-[18rem] lg:text-base md:text-sm text-[12.7px] justify-center border p-3 rounded-xl font-semibold font-jakarta"
            >
              <FcGoogle className="size-4" />
              Continue With Google
            </button>
            <button
              onClick={() => handleMicrosoftLogin()}
              className=" flex items-center gap-4 lg:w-[24rem] w-[18rem] lg:text-base md:text-sm text-[12.7px] justify-center border p-3 rounded-xl font-semibold font-jakarta"
            >
              <ReactSVG
                src={microsoftIcon}
                beforeInjection={(svg) => {
                  svg.setAttribute("class", "w-4 ");
                }}
              />
              Continue With Microsoft
            </button>
            <button
              onClick={handleAppleLogin}
              className="flex items-center gap-4 lg:w-[24rem] w-[18rem] lg:text-base md:text-sm text-[12.7px] justify-center border p-3 rounded-xl font-semibold font-jakarta"
            >
              <FaApple className="size-4" />
              Sign in with Apple
            </button>
          </div>
          <div className=" block text-[12.7px] font-inter text-center w-full text-[#4B4B4B] md:my-10">

            By using Zero Typing AI you agree to the <br />{" "}
            <a
              href="/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#006AFF] font-semibold hover:underline"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#006AFF] font-semibold hover:underline"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
